const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-f5f53907-45de-4e90-94b1-646007fc5182 {\n        fill: #5e3524;\n      }\n\n      .uuid-20f301b2-83d4-44af-b05b-f4d319ba5706 {\n        stroke-linecap: round;\n      }\n\n      .uuid-20f301b2-83d4-44af-b05b-f4d319ba5706, .uuid-d1c848d1-daf7-4b86-b4d9-7b6091fd28be, .uuid-80299a2b-c153-4064-bcc3-36cdcb9ca73c {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linejoin: round;\n      }\n\n      .uuid-80299a2b-c153-4064-bcc3-36cdcb9ca73c {\n        stroke-width: 2px;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-ab784ce8-37ff-4bda-b62d-30fd7f5d4df1",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-f5f53907-45de-4e90-94b1-646007fc5182",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-1963bcb7-4b24-49cd-8014-5d47421c4c08",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-d1c848d1-daf7-4b86-b4d9-7b6091fd28be",
  d: "M26.08,10.16s5.63,2.35,8.39,8.39"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-d1c848d1-daf7-4b86-b4d9-7b6091fd28be",
  d: "M22.96,10.91s7.21,3.02,10.76,10.76"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-d1c848d1-daf7-4b86-b4d9-7b6091fd28be",
  d: "M19.04,33.98s-5.63-2.35-8.39-8.39"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-d1c848d1-daf7-4b86-b4d9-7b6091fd28be",
  d: "M22.19,33.21s-7.21-3.02-10.76-10.76"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-80299a2b-c153-4064-bcc3-36cdcb9ca73c",
  d: "M29.29,28.8c-3.49,3.49-8.19,5.4-13.03,5.4-1.09,0-2.18-.1-3.27-.29-1.15-.21-2.06-1.12-2.26-2.26-1.07-5.95.84-12.04,5.1-16.31s10.36-6.16,16.3-5.1c1.15.2,2.06,1.11,2.26,2.26,1.07,5.94-.84,12.03-5.1,16.3Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-20f301b2-83d4-44af-b05b-f4d319ba5706",
  x1: 27.32,
  y1: 17.25,
  x2: 17.87,
  y2: 26.69
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-20f301b2-83d4-44af-b05b-f4d319ba5706",
  d: "M18.14,24.17s.37,1.49,2.31,2.31"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-20f301b2-83d4-44af-b05b-f4d319ba5706",
  d: "M20.27,22.04s.37,1.49,2.31,2.31"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-20f301b2-83d4-44af-b05b-f4d319ba5706",
  d: "M26.93,19.94s-.37-1.49-2.31-2.31"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-20f301b2-83d4-44af-b05b-f4d319ba5706",
  d: "M24.8,22.06s-.37-1.49-2.31-2.31"
}));
function SvgRepozeIconCategorySporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategorySporting);
export default __webpack_public_path__ + "static/media/repoze_icon_category-sporting.51009f8c70aa004f2113a810ce911895.svg";
export { ForwardRef as ReactComponent };